module.exports = __webpack_public_path__ + "img/07.a1db557d.jpg";